import {utility} from '../utilites'
import config from 'config';
import {Banner} from '../api/banner'

export const MESSAGE_NOTIFY = 'MESSAGE_NOTIFY';
export const MESSAGE_NOTIFY_HIDE = 'MESSAGE_NOTIFY_HIDE';
export const LOADING_BANNERS = 'LOADING_BANNERS';
export const LOADED_BANNERS = 'LOADED_BANNERS';
export const SAVING_BANNERS = 'SAVING_BANNERS';
export const SAVED_BANNERS = 'SAVED_BANNERS';
export const CREATE_BANNERS = 'CREATE_BANNERS';
export const UPDATE_BANNERS = 'UPDATE_BANNERS';
export const UPDATE_URL = 'UPDATE_URL';
export const UPDATE_LINK_TYPE = 'UPDATE_LINK_TYPE';
export const UPDATE_BANNER_PROMO = 'UPDATE_BANNER_PROMO';
export const CLEAN_PROPS = 'CLEAN_PROPS';
export const DELETE_BANNERS = 'DELETE_BANNERS';

export function save(bannerList, banners, club_id) {

  window.onbeforeunload = () => {
    return 'Do you want to leave this page? Unsaved data will be lost.';
  };

  let bannersContainer = {};
  Object.keys(banners).forEach(function (key) {
    if (banners[key] && banners[key] !== 'empty') {
      banners[key].modules = [];
    }
  });

  return async(dispatch)=> {
    dispatch(savingPartnerBanners(club_id));
    await bannerList.forEach((banner)=> {
      utility.networkLayer.patchFormData(
        `${config.backOfficeBasePath}/banners/` + banner.id, {
          club_id,
          'reference.type': banner.reference.type,
          'reference.uri': banner.reference.uri,
          'modules[0]': 'empty'
        }
      );
    });

    setTimeout(function () {
      Object.keys(banners).forEach(function (key) {
        if (banners[key] && banners[key] !== 'empty') {
          if (banners[key].modules.indexOf(key) == -1) {
            banners[key].modules.push(key);
          }

          bannersContainer[banners[key].id] = {
            modules: banners[key].modules,
            'reference.type': banners[key].reference.type,
            'reference.uri': banners[key].reference.uri
          };
        }
      });

      Object.keys(bannersContainer).forEach(async(id)=> {
        let modules = [];
        bannersContainer[id].modules.forEach((module, key)=> {
          modules['modules[' + key + ']'] = module;
        });

        let data = {
          club_id,
          'reference.type': bannersContainer[id]['reference.type'],
          'reference.uri': bannersContainer[id]['reference.uri']
        };

        Object.keys(modules).forEach((key)=> {
          data[key] = modules[key];
        });

        let saving = await utility.networkLayer.patchFormData(
          `${config.backOfficeBasePath}/banners/` + id, data
        );

        if (saving.status === 200) {
          window.onbeforeunload = null;
          return dispatch(savedPartnerBanners());
        } else {
          setTimeout(function () {
            return dispatch(savedPartnerBanners());
          }, 3000);
        }
      });
    }, 2000);


  }
}

export function load(club_id) {
  return async(dispatch)=> {
    dispatch(loadPartnerBanners(club_id));

    let banners = await utility.networkLayer.getJson(`${config.backOfficeBasePath}/banners/` + club_id);
    return dispatch(loadedPartnerBanners(banners));
  }
}

export function create(image, club_id) {

  let reference_type = ['external'];
  let reference_uri = '';

  return async(dispatch) => {
    let banner = await Banner.fromFile(image);
    let result = await utility.networkLayer.postFormData(
      `${config.backOfficeBasePath}/banners`,
      {
        modules: [],
        'reference.type': reference_type[0],
        'reference.uri': reference_uri,
        club_id: club_id,
        name: banner.image.file
      }
    );

    if (result.status === 200) {
      dispatch(createPartnerBanners(banner));
    }

    let banners = await utility.networkLayer.getJson(`${config.backOfficeBasePath}/banners/` + club_id);

    dispatch(cleanProperties());
    return dispatch(loadedPartnerBanners(banners));
  }
}

export function update(image, key, banner, club_id) {
  return async(dispatch) => {

    await utility.networkLayer.patchFormData(
      `${config.backOfficeBasePath}/banners/` + banner.id,
      {
        club_id: club_id,
        'reference.type': banner.reference.type,
        'reference.uri': banner.reference.uri,
        name: image.file
      }
    );
    return dispatch(updatePartnerBanners(image, key));
  }
}

export function updateUrl(url, key) {
  return async(dispatch) => {
    return await dispatch(updateUrlPartnerBanners(url, key));
  }
}

export function updateLinkType(linkType, key) {
  return async(dispatch) => {
    return dispatch(updateLinkPartnerBanners(linkType, key));
  }
}

export function updateBannerPromoLink(key, banner, promo) {
  return async(dispatch) => {
    return dispatch(updateBannerPromo(key, banner, promo));
  }
}

export function deleteBanner(key, id, club_id) {
  return async(dispatch) => {
    await utility.networkLayer.removeJson(
      `${config.backOfficeBasePath}/banners/` + id,
      {
        club_id: club_id
      }
    );
    return dispatch(deletePartnerBanners(key));
  }
}

function createPartnerBanners(banner) {
  return {
    type: CREATE_BANNERS,
    banner
  };
}

function loadPartnerBanners(id) {
  return {
    type: LOADING_BANNERS,
    club_id: id,
    loading: false
  };
}

function loadedPartnerBanners(banners) {
  return {
    type: LOADED_BANNERS,
    banners
  }
}

function updatePartnerBanners(image, key) {
  return {
    type: UPDATE_BANNERS,
    image,
    key
  }
}

function updateUrlPartnerBanners(url, key) {
  return {
    type: UPDATE_URL,
    url,
    key
  };
}

function updateLinkPartnerBanners(linkType, key) {
  return {
    type: UPDATE_LINK_TYPE,
    linkType,
    key
  };
}

function updateBannerPromo(key, banner, promo) {
  return {
    type: UPDATE_BANNER_PROMO,
    key,
    banner,
    promo
  };
}

function savingPartnerBanners(id) {
  return {
    type: SAVING_BANNERS,
    club_id: id,
    loading: true
  };
}

function savedPartnerBanners() {
  return {
    type: SAVED_BANNERS,
    loading: false
  };
}

function cleanProperties() {
  return {
    type: CLEAN_PROPS
  };
}
function deletePartnerBanners(key) {
  return {
    type: DELETE_BANNERS,
    key
  };
}





// WEBPACK FOOTER //
// ./src/actions/partnerBanner.js